<div>
  <mat-tab-group>
    <mat-tab *ngIf="aclGroup.fileInbox.showMyFiles">
      <ng-template mat-tab-label>
        Files       
      </ng-template>
      <ng-template matTabContent>
        <app-myfiles *ngIf="display" [filesList]="myFilesList" (reload)="onReload($event)">
        </app-myfiles>
        <!-- <app-dialog-folder></app-dialog-folder> -->
      </ng-template>
    </mat-tab>    
    <mat-tab>
      <ng-template mat-tab-label>
        Display Duplicates
        <!-- <button mat-icon-button (click)="refreshDuplicate($event)">
          <mat-icon>refresh</mat-icon>
        </button> -->
      </ng-template>
      <ng-template matTabContent>
        <app-duplicate *ngIf="display" [filesList]="duplicateList">
        </app-duplicate>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        Index Documents
        <!-- <button mat-icon-button (click)="refreshDuplicate($event)">
          <mat-icon>refresh</mat-icon>
        </button> -->
      </ng-template>
      <ng-template matTabContent>
        <app-index-documents *ngIf="display">
        </app-index-documents>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="aclGroup.fileInbox.showTeamFiles && isAdmin">
      <ng-template mat-tab-label>
        Manage Teams
      </ng-template>
      <ng-template matTabContent>
        <app-teamfiles *ngIf="display">
        </app-teamfiles>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="isAdmin">
      <ng-template mat-tab-label>
        Reports
        <!-- <button mat-icon-button (click)="refreshDuplicate($event)">
          <mat-icon>refresh</mat-icon>
        </button> -->
      </ng-template>
      <ng-template matTabContent>
        <app-reports *ngIf="display">
        </app-reports>
      </ng-template>
    </mat-tab>        
  </mat-tab-group>
</div>